import { autoMount } from '../../../utils/autoMount';
import { CarefulRegistration } from '../../../components/pages/carefulRegistration';

autoMount({ CarefulRegistration });
